<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <div
        style="
          font-family: Consolas, 'Courier New', monospace;
          line-height: 19px;
        "
      >
        <div>
          &nbsp;为了提升买家的购物体验，维持市场正常运营秩序，美滋来外卖按照规定的情形对入网食品生产经营者经营行为进行规范。
        </div>
        <div>&nbsp; &nbsp; &nbsp; 1、美滋来外卖商家违规处罚措施包括:</div>
        <div>
          &nbsp; &nbsp; &nbsp;
          1)警告:指平台通过口头或书面的形式对用户的不当行为进行提醒和告诫;
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          2)下架:指将卖家在售商品/服务的状态转移至待售中的商品;
        </div>
        &nbsp; &nbsp; &nbsp; 3)限制参加营销活动:
        <div>&nbsp; &nbsp; &nbsp; 指限制卖家参加平台官方发起的营销活动;</div>
        <div>
          &nbsp; &nbsp; &nbsp;
          4)门店置休:指在一段的时间段内对门店进行置休处理，不能营业;
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          5)门店下线:指删除商家的店铺，下架店铺内所有出售中的商品，禁止发布商品，并禁止创建店铺。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          2、商家若发生危及交易安全或扰乱平台运营秩序等行为，平台将依照其行为的危险程度采取账户强制措施、门店置休等保障交易安全的临时性管理措施:情形严重的，平台有权依照相关规则采取违规处理，要求卖家承担违约责任。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          3、美滋来外卖商家若违反关于商品或信息发布的规定，将对其违规商品或信息给予下架或删除处理。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          4、新闻媒体曝光或国家质监部门通报的质量不合格的品牌、品类或批次的商品及信息，美滋来外卖将对卖家在售的相关商品及信息进行临时性下架或删除处理。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          5、商家参与美滋来外卖活动及活动展示时，应符合相关活动规则。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          6、如果美滋来外卖商家店铺被关闭，将按照合同约定及规则办理店铺关闭手续，并按约定情形办理终止服务事宜。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          7、卖家未按要求进行经营主体信息公示的(要求在店铺首页显著位置公示营业执照、食品生产经营许可，食品安全量化分级信息)，由平台运营部门督促经营者公示并及时上传公示，超过7日未未提供的，停止经营者后台服务，超过15日未提供的，强制下架该经营者店铺内所有商品、冻结账户
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          8、卖家超范围经营、提供虚假信息的，由美滋来外卖运营部门及时制止责令改正。拒不改正的，强制下架该经营者店铺内所有商品、冻结账户，违反食品安全法规定，构成犯罪的，向所在地食药监部门报告依法追究刑事责任。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          9、卖家销售产品出现质量不合格、影响食品安全或接到客户投诉的由美滋来外卖运营部门按《食品安全投诉举报处理》相关规定处理。违反食品安全法规定，构成犯罪的，向所在地食药监部门报告，依法追究刑事责任。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
